"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ExpansionPanelActions.default;
  }
});

var _ExpansionPanelActions = _interopRequireDefault(require("./ExpansionPanelActions"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/ExpansionPanelActions/index.js
// module id = 581
// module chunks = 0